// extracted by mini-css-extract-plugin
module.exports = {"servicesContainer":"Services_servicesContainer__J_eMd","lastWords":"Services_lastWords__985Uv"};